import { render } from "./JumpLinkFeatured.vue?vue&type=template&id=59ed5d66&scoped=true"
import script from "./JumpLinkFeatured.vue?vue&type=script&lang=js"
export * from "./JumpLinkFeatured.vue?vue&type=script&lang=js"

import "./JumpLinkFeatured.vue?vue&type=style&index=0&id=59ed5d66&scoped=true&lang=less"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59ed5d66"]])

export default __exports__